import React, { useContext } from 'react'
import DrupalContext from 'contexts/DrupalContext'

function Preamble() {
  const drupal = useContext(DrupalContext)
  return !drupal.preamble ? null : (
    <div className="formatted-content preamble preamble--large u-mb-200" dangerouslySetInnerHTML={{ __html: drupal.preamble }} />
  )
}

export default Preamble
